var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { KeycloakService } from '../../services/keycloak.service';
import { ExpedienteFilterComponent } from './expediente-filter.component';
import { ExpedienteService } from '../../services/expediente.service';
import { SharedService } from '../../services/shared.service';
var ExpedienteListComponent = (function () {
    function ExpedienteListComponent(_service, _expService, route) {
        this._service = _service;
        this._expService = _expService;
        this.route = route;
        this.busquedavisible = false;
        this.searchFilter = { fecha_desde: "", fecha_hasta: "", cir_id: 0, org_id: 0, caratula: "", movimiento: false, favorito: false,
            usrCod: KeycloakService.getLoggedUser(), page: 0, size: 10 };
    }
    ExpedienteListComponent.prototype.ngOnInit = function () {
        var _this = this;
        // var date = new Date(); 
        // this.searchFilter.fecha_desde = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
        // this.searchFilter.fecha_desde = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
        this._subscription = ExpedienteFilterComponent.observable().subscribe(function (item) { return _this.searchAction(item); });
        this.route.queryParams.subscribe(function (param) {
            //console.log('param q');
            var filter = JSON.parse(atob(param["q"]));
            _this.searchAction(filter);
        });
    };
    ExpedienteListComponent.prototype.searchAction = function (filter) {
        var _this = this;
        this.hideErrorMsg();
        this.searchFilter = filter;
        this.searchFilter.page = 0;
        this._expService.findAvanzada(this.armarString()).subscribe(function (response) {
            _this.expedientes = response;
            _this.dataShowing = _this.expedientes.data;
            _this.showing = _this.dataShowing.length;
            if (_this.expedientes.total == 0) {
                _this.showErrorMessage("No se han encontrado resultados");
            }
        });
    };
    ExpedienteListComponent.prototype.limpiar = function () {
        this.searchFilter = { fecha_desde: "", fecha_hasta: "", cir_id: 0, org_id: 0, caratula: "", movimiento: false, favorito: false,
            usrCod: KeycloakService.getLoggedUser(), page: 0, size: 10 };
    };
    ExpedienteListComponent.prototype.buscar = function () {
        //console.log(JSON.stringify(this.searchFilter));
    };
    ExpedienteListComponent.prototype.cargarMasExpedientes = function () {
        var _this = this;
        this.searchFilter.page = this.searchFilter.page + 1;
        this._expService.findAvanzada(this.armarString()).subscribe(function (response) {
            _this.expedientes = response;
            _this.expedientes.data.forEach(function (element) {
                _this.dataShowing.push(element);
            });
            _this.showing = _this.dataShowing.length;
            //console.log(this.dataShowing);
        });
    };
    ExpedienteListComponent.prototype.armarString = function () {
        this.searchFilter.size = 10;
        //console.log("-> q = " + JSON.stringify(this.searchFilter));
        //console.log("search q --> " + btoa(JSON.stringify(this.searchFilter)));
        return btoa(SharedService.unescape(encodeURIComponent(JSON.stringify(this.searchFilter))));
    };
    ExpedienteListComponent.prototype.ngOnDestroy = function () {
        // prevent memory leak when component is destroyed
    };
    ExpedienteListComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    ExpedienteListComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
    };
    return ExpedienteListComponent;
}());
ExpedienteListComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'my-app',
        templateUrl: 'expediente-list.component.html'
    }),
    __metadata("design:paramtypes", [CommonService, ExpedienteService, ActivatedRoute])
], ExpedienteListComponent);
export { ExpedienteListComponent };
//# sourceMappingURL=expediente-list.component.js.map